import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyD7VhwX-my7A7Jjy09izNtYCb67KXwO-9I",
  authDomain: "gonzalo-alonso.firebaseapp.com",
  projectId: "gonzalo-alonso",
  storageBucket: "gonzalo-alonso.appspot.com",
  messagingSenderId: "155625200856",
  appId: "1:155625200856:web:3f781439583054042b4bad",
  measurementId: "G-V6WPLTRSFH",
};

const app = initializeApp(firebaseConfig);
